// extracted by mini-css-extract-plugin
export var searchHeader = "_7p-0";
export var searchHeaderDark = "_7p-1";